import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, OnDestroy } from '@angular/core';
import { Customer } from 'src/app/api/customer/customer';
import { CustomerApiService } from 'src/app/api/customer/customerApiService';
import { CustomerSearchQuery } from 'src/app/api/customer/customerSearchQuery';
import { SearchStateService } from 'src/app/services/search-state/search-state.service';
import { Const } from 'src/app/const';

@Component({
    selector: 'customer-search',
    templateUrl: './customer-search.component.html',
    styleUrls: ['./customer-search.component.css'],
    host: {'class': 'asset-search'},
    standalone: false
})
export class CustomerSearchComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('loadingTrigger') loadingTrigger!: ElementRef;
  private observer: IntersectionObserver | null = null;
  loading: boolean = false;
  moreDataAvailable: boolean = false;
  pagingKey: string | null = null;
  customerSearchQuery: CustomerSearchQuery = new CustomerSearchQuery();
  customers: Customer[] | null = null;

  constructor(
    private customerApiService: CustomerApiService,
    private searchStateService: SearchStateService
  ) { }

  ngOnInit(): void {
    const savedState = this.searchStateService.getCustomerSearchState();
    if (savedState) {
        this.customerSearchQuery = savedState;
        this.onSearchCustomer();
    }
    
    this.initializeIntersectionObserver();
  }

  private initializeIntersectionObserver(): void {
    this.observer = new IntersectionObserver(
        (entries) => {
            if (entries[0].isIntersecting && !this.loading && this.moreDataAvailable) {
                this.loadMoreCustomers();
            }
        },
        { threshold: 0.5 }
    );
  }

  ngAfterViewInit(): void {
    if (!this.loadingTrigger) {
        console.warn('Loading trigger element not found in template');
        return;
    }

    if (this.loadingTrigger && this.observer) {
        this.observer.observe(this.loadingTrigger.nativeElement);
    }
  }

  ngOnDestroy(): void {
    if (this.observer) {
        this.observer.disconnect();
    }
  }

  onSearchCustomer(): void {
    this.loading = true;
    this.customers = null;
    this.pagingKey = null;

    this.searchStateService.saveSearchState(this.customerSearchQuery);

    this.customerApiService.searchCustomers(this.customerSearchQuery, null, Const.SEARCH_QUERY_LIMIT)
      .subscribe(customers => this.handleSearchResults(customers));
  }

  private handleSearchResults(customers: Customer[]) {
    this.loading = false;
    this.customers = customers;
    this.pagingKey = customers.length > 0 ? customers[customers.length - 1].pagingKey : null;
    this.moreDataAvailable = customers.length == Const.SEARCH_QUERY_LIMIT;
  }

  loadMoreCustomers(): void {
    this.loading = true;

    this.customerApiService.searchCustomers(this.customerSearchQuery, this.pagingKey, Const.SEARCH_QUERY_LIMIT)
      .subscribe(customers => this.handleLoadMoreResults(customers));
  }

  private handleLoadMoreResults(customers: Customer[]) {
    this.loading = false;
    this.customers = this.customers!.concat(customers);
    this.pagingKey = customers.length > 0 ? customers[customers.length - 1].pagingKey : null;
    this.moreDataAvailable = customers.length == Const.SEARCH_QUERY_LIMIT;
  }
}
